import React from "react";
import NavBar from "../components/Navbar5";
import ContactForm from "../components_contact/ContactForm";
import styles from "../styles_contact/ContactPage.module.css";
import Footer from "../components/Footer1";
import SEO from "../components/SEO";

const contactPageSchema = {
  "@context": "https://schema.org",
  "@type": "ContactPage",
  name: "Contact VishvaConnect Technologies LLP",
  url: "https://www.vishvaconnect.com/contact",
  description:
    "Contact VishvaConnect Technologies LLP to discuss custom software development, website development, government portals, software testing and automation solutions.",
  mainEntity: {
    "@type": "Organization",
    name: "VISHVACONNECT TECHNOLOGIES LLP",
    url: "https://www.vishvaconnect.com/",
    email: "vishvaconnect7@gmail.com",
    sameAs: [
      "https://www.linkedin.com/company/vishvaconnect/",
      "https://www.youtube.com/@VishvaConnect",
    ],
  },
};

function ContactPage() {
  return (
    <div style={{ background: "#0f172a" }}>
      <SEO
        title="Contact VishvaConnect | Discuss Your Software Project"
        description="Contact VishvaConnect Technologies LLP for custom software, website development, software testing, government portals, automation and MIS dashboard solutions."
        path="/contact"
        schema={contactPageSchema}
      />
      <NavBar />
      <div className={styles.contactPageWrapper}>
        <div className={styles.contactHeadingSection}>
          <h1 className={styles.contactMainHeading}>Get In Touch</h1>
          <p className={styles.contactSubHeading}>
            Have a question, suggestion, or just want to say hello? We're here
            to help and would love to hear from you.
          </p>
        </div>
        <ContactForm />
      </div>
      <Footer />
    </div>
  );
}

export default ContactPage;
